import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';
export default function () {
    return {
        wrapper: this.$el,
        showAllFilters: false,
        maxLineVisible: 3,
        hideMainFilters: [],
        items: [],
        init() {
            new SimpleBar(document.getElementById('active-filters'), {
                autoHide: false
            });

            this.items = Array.from(
                this.wrapper.querySelectorAll(
                    'ol > li.applied-filters__item:not(.hidden)'
                )
            );

            this.updateVisibilityMainFilters();

            window.addEventListener('resize', () => this.resizeTriggerEvent());
        },
        resizeTriggerEvent() {
            if (window.innerWidth > 768) {
                this.updateVisibilityMainFilters();
            }
        },
        toggleVisibilityMainFilters() {
            this.showAllFilters = !this.showAllFilters;
            this.updateVisibilityMainFilters();
        },
        btnTextToggleVisibilityMainFilters(btnText) {
            if (this.showAllFilters) {
                return btnText;
            } else {
                return `+${this.hideMainFilters.length}`;
            }
        },
        updateVisibilityMainFilters() {
            const btnClearFilterWidth =
                this.wrapper.querySelector('.filter-clear').offsetWidth;
            const containerWidth = this.wrapper.querySelector('ol').offsetWidth;
            const maxContainerWidth = containerWidth - btnClearFilterWidth - 8;
            const gap = 8;
            let currentWidth = 0;
            let lineCount = 1;

            this.items.forEach((item) => {
                if (!item.classList.contains('main-action')) {
                    if (this.showAllFilters) {
                        item.classList.add('main-item-show');
                        item.classList.remove('main-item-hide');
                    } else {
                        item.classList.add('main-item-show');
                        item.classList.remove('main-item-hide');
                        const itemWidth = item.offsetWidth + gap;
                        const dynamicMaxContainer =
                            lineCount === 3
                                ? maxContainerWidth
                                : containerWidth;
                        if (currentWidth + itemWidth > dynamicMaxContainer) {
                            lineCount += 1;
                            currentWidth = 0;
                        }
                        currentWidth += itemWidth;

                        if (
                            lineCount > this.maxLineVisible &&
                            !this.showAllFilters
                        ) {
                            const mainFilterId =
                                item.getAttribute('data-main-filter');
                            const mainFilterItems =
                                this.wrapper.querySelectorAll(
                                    `[data-main-filter="${mainFilterId}"]`
                                );

                            if (!this.hideMainFilters.includes(mainFilterId)) {
                                this.hideMainFilters.push(mainFilterId);
                            }

                            mainFilterItems.forEach((item) => {
                                item.classList.remove('main-item-show');
                                if (
                                    !item.classList.contains('main-item-hide')
                                ) {
                                    item.classList.add('main-item-hide');
                                }
                            });
                        }
                    }
                }
            });
        }
    };
}
